import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { UserStateService } from '@core/services/authApiService/user-state-service.service';

export const authGuard: CanMatchFn = () => {
  const userState = inject(UserStateService);
  const router = inject(Router);

  if (userState.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree(['/sign-in']);
};
